import { type Block, type Exercise, type Target, groupCount } from "./models.js";

/** WeightsCore's `PlanText.render`: blocks written back the way the coach writes them. */
export function renderPlan(blocks: Block[]): string {
  const prep = blocks.filter((b) => b.isPrep && b.exercises.length > 0);
  const main = blocks.filter((b) => !b.isPrep && b.exercises.length > 0);
  const lines: string[] = [];
  if (prep.length > 0) {
    lines.push("Prep:");
    for (const block of prep) lines.push(...renderBlock(block, true));
    if (main.length > 0) lines.push("Main:");
  }
  for (const block of main) lines.push(...renderBlock(block, prep.length > 0));
  return lines.join("\n");
}

function renderBlock(block: Block, bulleted: boolean): string[] {
  const lead = bulleted ? "- " : "";
  const inner = bulleted ? "  - " : "- ";
  const only = block.exercises.length === 1 ? block.exercises[0]! : null;
  if (only !== null && only.target !== null && groupCount(only) === null) {
    const count = block.sets > 1 || !block.isPrep ? `${block.sets}x` : "";
    return [lead + count + item(only, only.target, block.note)];
  }
  const header = `${block.sets} sets` + (block.note !== null ? ` (${block.note})` : "");
  return [
    lead + header,
    ...block.exercises.map((e) => inner + (e.target !== null ? item(e, e.target, null) : named(e, null))),
  ];
}

function item(exercise: Exercise, target: Target, extraNote: string | null): string {
  const groups = groupCount(exercise);
  return (groups !== null ? `${groups}x` : "") + `${amount(target)} ` + named(exercise, extraNote);
}

function named(exercise: Exercise, extraNote: string | null): string {
  const note = [exercise.note, extraNote].filter((n): n is string => n !== null && n !== "").join(" · ");
  return exercise.name + (exercise.perSide ? "*" : "") + (note === "" ? "" : ` (${note})`);
}

function amount(target: Target): string {
  const number = target.upper !== null ? `${target.amount}-${target.upper}` : `${target.amount}`;
  return target.unit === "reps" ? number : target.unit === "seconds" ? number + "s" : number + "m";
}
